export default __webpack_public_path__ + "static/MultimodalTransportationHubsAndConnections-51a88aee85b8a88ee38e97a63998423d.jpg";